// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBar_wrapper__4m3K5","menu":"NavBar_menu__TNXUj","logo":"NavBar_logo__Rgo-5"};